<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card color="success" icon="mdi-clipboard-text" inline title="Proveedores"
      class="px-5 py-3 mb-5">
      <v-row>
        <v-col cols="12" md="6">
          <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones" item-text="name"
            item-value="id" persistent-hint return-object single-line v-on:change="listarEdificios()"></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name" item-value="id"
            persistent-hint return-object single-line v-on:change="listar()"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="mt-10">
          <v-data-table :headers="headers" :items="Suppliers" sort-by="calories" class="elevation-1" :search="search"
            :loading="loadingTable" loading-text="Cargando... Por favor esperar">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Propiedades</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>

                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="editedIndex = -1">
                      Nueva Propiedad<caption></caption>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ formTitle }} </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <v-form ref="form" v-model="validForm">
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="name" label="Nombre" :rules="requiredRule" required />
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="ruc" label="RUC" :rules="requiredRule" required />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="contact_person" label="Contacto" />
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="phone" label="Teléfono" />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="email" label="Email" />
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="address" label="Dirección" />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="bank_name" label="Banco" />
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="bank_account" label="Cuenta Bancaria" />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-select v-model="account_type" :items="['Ahorros', 'Corriente']" label="Tipo de cuenta"
                                dense filled clearable />
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="notes" label="Notas" />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="close"> Cerrar </v-btn>
                      <v-btn color="primary" @click="guardar()"> Guardar </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Esta seguro de eliminar datos?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="editar(item)">
                    <v-icon dense color="secondary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="deleteItem(item)">
                    <v-icon dense color="primary">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Recargar </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "DashboardExtendedTables",

  data: () => ({
    selectedId: '',
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'RUC', value: 'ruc' },
      { text: 'Contacto', value: 'contact_person' },
      { text: 'Teléfono', value: 'phone' },
      { text: 'Email', value: 'email' },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    Suppliers: [],
    editedIndex: -1,
    //medicamento: "",
    //presentacion: "",
    //literatura: "",
    search: "",
    loadingTable: false,
    snackbar: false,
    text: "",
    timeout: 6000,
    urbanizaciones: [],
    urbanizacion: [],
    edificios: [],
    edificio: [],
    //popup
    id: '',
    name: '',
    ruc: '',
    contact_person: '',
    phone: '',
    email: '',
    address: '',
    bank_name: '',
    bank_account: '',
    account_type: '',
    notes: '',
    requiredRule: [(v) => !!v || 'Este campo es obligatorio'],

    validForm: false,


  }),

  computed: {

    formTitle() {
      return this.editedIndex === -1 ? "Nueva propiedad" : "Editar propiedad";
    },

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listarUrbanizaciones();
    },
    listarUrbanizaciones() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Communities", configuracion)
        .then(function (response) {
          me.urbanizaciones = response.data;
          me.Properties = []; //limpiar propiedades cuando selecciono otra urbanizacion
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarEdificios() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.edificios = [];
      axios
        .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
        .then(function (response) {
          me.edificios = response.data;
          me.Properties = []; //limpiar propiedades cuando selecciono otra urbanizacion
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listar() {
      let me = this;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.loadingTable = true;
      me.Properties = [];
      axios
        .get("/api/Suplliers/SuppliersByBuilding/" + me.edificio.id, configuracion)
        .then(function (response) {
          me.Suppliers = response.data;
          //change to string bool value
          me.loadingTable = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      console.log("Entre antes de guardar");
      if (this.$refs.form.validate()) {
        if (me.editedIndex > -1) {
          //edit
          console.log("editar propiedad");
          axios
            .post(
              "/api/Suplliers/UpdateSupplier",
              {
                id: me.id,
                name: me.name,
                ruc: me.ruc,
                contact_person: me.contact_person,
                phone: me.phone,
                email: me.email,
                address: me.address,
                bank_name: me.bank_name,
                bank_account: me.bank_account,
                account_type: me.account_type,
                notes: me.notes,
                user_id: localStorage.getItem("unico")
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              me.$refs.form.reset();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        } else {
          console.log("crear propiedad");
          axios
            .post(
              "/api/Suplliers/InsertSuppliers",
              {
                building_uq: me.edificio.id,
                name: me.name,
                ruc: me.ruc,
                contact_person: me.contact_person,
                phone: me.phone,
                email: me.email,
                address: me.address,
                bank_name: me.bank_name,
                bank_account: me.bank_account,
                account_type: me.account_type,
                notes: me.notes,
                user_id: localStorage.getItem("unico")
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              me.$refs.form.reset();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 400) {
                me.snackbar = true;
                me.text = err.response.data.errors;
              }
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        }
        me.close();
      }

    },

    deleteItem(item) {
      let me = this;
      me.selectedId = item.id;
      console.log(item);
      me.dialogDelete = true;
    },
    deleteItemConfirm() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Properties/Delete/" + me.selectedId, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          }
          me.listar();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },

    editar(item) {
      let me = this;
      me.id = item.id;
      me.Propietario = item.owner;
      me.Tipo = item.propertyType;
      me.No = item.unitNumber;
      me.Piso = item.floor;
      me.Area = item.area;
      me.TipoDocuemnto = item.documentType;
      me.NoDocumento = item.documentNo;
      me.Email = item.email;
      me.Telefono = item.phone;

      me.editedIndex = 1;
      me.dialog = true;
    },
    close() {
      let me = this;
      me.dialog = false;

    },
    closeDelete() {
      this.dialogDelete = false;

    },
  },
};
</script>